export default __webpack_public_path__ + "media/images/app-icon-58b3f870037a178c007a9cffeaaba11a.svg";